import React, { JSX, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getTokenAccessInfo } from "../utils/jwt";

export default function RequireAuth({ children }: { children: JSX.Element }) {
  const navigate = useNavigate();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem("authToken");
      
      // Token yoksa login sayfasına yönlendir
      if (!token) {
        navigate("/login");
        return;
      }

      // Token claim'lerinden panel erişimini kontrol et
      const access = getTokenAccessInfo(token);

      if (!access.hasPanelAccess) {
        // Yetki yoksa token'ı temizle ve login'e yönlendir
        localStorage.removeItem("authToken");
        alert("Bu panele yalnızca yetkili kullanıcılar erişebilir (ADMIN/CONTENT_MANAGER).");
        navigate("/login");
        return;
      }

      setIsChecking(false);
    };

    checkAuth();
  }, [navigate]);

  // Auth kontrolü devam ederken loading göster
  if (isChecking) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        Yetki kontrol ediliyor...
      </div>
    );
  }

  return children;
}
